import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Modal from '../../../../components/Modal';
import message from '../../../../constant/message';
import LenderUgroService from '../../../../services/lender';
import Button from '../../../../components/Common/Button';

const MandateModal = ({ userType, state, toggleModal, leadId, reloadTable, rowData, selectedLender, editMode, lafNumber }) => {
    const [loading, setLoading] = useState(false);
    const [mandateType, setMandateType] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [umrn, setUmrn] = useState('');
    const [mandateAmount, setMandateAmount] = useState('');
    const [frequency, setFrequency] = useState('');
    const [bankName, setBankName] = useState('');
    const [ifsc, setIFSC] = useState('');
    const [accountType, setAccountType] = useState('');
    const [accountNo, SetAccountNo] = useState('');
    const [lenderID, setLenderID] = useState(selectedLender)
    const [errors, setErrors] = useState();
    const [showConfirmationModal, setShowConfirmationModal] = useState(false)

    useEffect(() => {
        setLenderID(rowData?.cl_lender_id || selectedLender)
        setMandateType(rowData?.mandate_type);
        setCustomerName(rowData?.cust_name)
        setUmrn(rowData?.umrn);
        setMandateAmount(rowData?.mandate_amt);
        setFrequency('Monthly');
        setBankName(rowData?.bank_name);
        setIFSC(rowData?.ifsc);
        setAccountType(rowData?.acc_type);
        SetAccountNo(rowData?.acc_no)
        // setBankNameByIFSC()
    }, [])

    useEffect(()=>{
        if (ifsc.length > 10) {
            fetchBankDetailsByIfsc(ifsc)
        }
    }, [ifsc])

    // const setBankNameByIFSC = () => {
    //     if(!rowData?.lead_mandate_id && rowData?.ifsc){
    //         fetchBankDetailsByIfsc(rowData?.ifsc);
    //     }
    // }

    const formSubmitHandler = async () => {
        try {
            setLoading(true);
            const formData = new FormData();
            if (editMode) {
                mandateType && formData.append('mandate_type', mandateType);
                customerName && formData.append('cust_name', customerName);
                umrn && formData.append('umrn', umrn);
                mandateAmount && formData.append('mandate_amt', mandateAmount);
                frequency && formData.append('frequency', frequency);
                bankName && formData.append('bank_name', bankName);
                ifsc && formData.append('ifsc', ifsc);
                accountNo && formData.append('acc_no', accountNo);
                accountType && formData.append('acc_type', accountType);
                leadId && formData.append('cl_lead_id', leadId);
                lenderID && formData.append('cl_lender_id', lenderID);
                rowData?.lead_mandate_id && formData.append('lead_mandate_id', rowData?.lead_mandate_id);
            } else {
                mandateType && formData.append('mandate_type', mandateType);
                customerName && formData.append('cust_name', customerName);
                umrn && formData.append('umrn', umrn);
                mandateAmount && formData.append('mandate_amt', mandateAmount);
                frequency && formData.append('frequency', frequency);
                bankName && formData.append('bank_name', bankName);
                ifsc && formData.append('ifsc', ifsc);
                accountNo && formData.append('acc_no', accountNo);
                accountType && formData.append('acc_type', accountType);
                leadId && formData.append('cl_lead_id', leadId);
                lenderID && formData.append('cl_lender_id', lenderID);
            }
            let apiResponse = await LenderUgroService.addMandate({
                type: userType,
                formData,
                subType: userType === 'admin' ? 'co-lender' : '',
            });
            if (apiResponse?.data?.status?.code === 1) {
                toast.success(
                    apiResponse?.data?.data?.messages?.[0]?.[0] || message.SAVED_SUCCESS
                );
                setShowConfirmationModal(false);
                toggleModal();
                reloadTable();
            }
        } catch (err) {
            setLoading(false);
            setShowConfirmationModal(false)
            let error = err?.response?.data?.messages?.error;
            toast.error(error?.form?.[0] || error?.others?.[0]);
            setErrors(error?.fields);
        }
    };

    const handleConfirmationModal = () => {
        formSubmitHandler();
    }

    const fetchBankDetailsByIfsc = (ifsc) => {
        fetch(`https://ifsc.razorpay.com/${ifsc}`)
            .then(response => response.json())
            .then(data => {
                setBankName(data?.BANK)
            })
            .catch(error => console.error('Error:', error));
    }

    return (
        <>
        <Modal state={state} closeModal={toggleModal} style={{ width: "450px" }} removeBorderSpace={true}>
            <div className="modal-header-container">
                <div className="modal-title">Mandate Details (<span style={{ color: "#4A4E88", fontSize: '12px' }}>LAF : {`${lafNumber}`}</span>)</div>
                <div className="closeModalView" onClick={toggleModal}>
                    <span className="closeModalIcon">x</span>
                </div>
            </div>
            <div className='p-4'>
                <div style={{ height: "400px", overflowY: "scroll", overflowX: 'clip', padding: "2%" }}>
                    <div class='form-group'>
                        <label>Mandate Type <tt>*</tt></label>
                        <div class='row'>
                            <div class='col-12'>
                                <select
                                    class='form-control custom-form-control'
                                    onChange={(e) => setMandateType(e.target.value)}
                                    value={mandateType}
                                    disabled={rowData?.mandate_type ? true : false}
                                >
                                    <option value={''}>Please Select</option>
                                    <option value={'ENACH'}>eNACH</option>
                                    <option value={'PHYSICAL'}>Physical NACH</option>
                                </select>
                            </div>
                        </div>
                        <tt>
                            {errors && errors?.mandate_type}
                        </tt>
                    </div>
                    <div class='form-group'>
                        <label>Customer Name <tt>*</tt></label>
                        <div class='row'>
                            <div class='col-12'>
                                <input
                                    class='form-control custom-form-control'
                                    value={customerName}
                                    disabled={rowData?.cust_name ? true : false}
                                    onChange={(e) => setCustomerName(e.target.value)}
                                    maxlength={50}
                                />
                            </div>
                        </div>
                        <tt>
                            {errors && errors?.cust_name}
                        </tt>
                    </div>
                    <div class='form-group'>
                        <label>UMRN <tt>*</tt></label>
                        <div class='row'>
                            <div class='col-12'>
                                <input
                                    class='form-control custom-form-control'
                                    type='text'
                                    value={umrn}
                                    onChange={(e) => setUmrn(e.target.value.replace(/[^A-Za-z0-9]/g, ''))}
                                    maxlength="20"
                                />
                            </div>
                        </div>
                        <tt>
                            {errors && errors?.umrn}
                        </tt>
                    </div>
                    <div class='form-group'>
                        <label>Mandate Amount <tt>*</tt></label>
                        <div class='row'>
                            <div class='col-12'>
                                <input
                                    class='form-control custom-form-control'
                                    type='text'
                                    value={mandateAmount}
                                    disabled={rowData?.mandate_amt ? true : false}
                                    onChange={(e) => setMandateAmount(e.target.value.replace(/[^0-9.]/g, ''))}
                                    maxlength="15"
                                />
                            </div>
                        </div>
                        <tt>
                            {errors && errors?.mandate_amt}
                        </tt>
                    </div>
                    <div class='form-group'>
                        <label>IFSC <tt>*</tt></label>
                        <div class='row'>
                            <div class='col-12'>
                                <input
                                    class='form-control custom-form-control'
                                    style={{'text-transform': 'uppercase'}}
                                    value={ifsc}
                                    disabled={rowData?.ifsc ? true : false}
                                    onChange={(e) => {
                                                setIFSC(e.target.value.replace(/[^A-Za-z0-9]/g, ''))
                                            }}
                                    maxlength="11"
                                />
                            </div>
                        </div>
                        <tt>
                            {errors && errors?.ifsc}
                        </tt>
                    </div>
                    <div class='form-group'>
                        <label>Bank Name <tt>*</tt></label>
                        <div class='row'>
                            <div class='col-12'>
                                <input
                                    class='form-control custom-form-control'
                                    value={bankName}
                                    disabled={rowData?.bank_name ? true : false}
                                    onChange={(e) => setBankName(e.target.value.replace(/[^A-Za-z ]/g, ''))}
                                    maxlength="50"
                                />
                            </div>
                        </div>
                        <tt>
                            {errors && errors?.bank_name}
                        </tt>
                    </div>
                    <div class='form-group'>
                        <label>Account Type <tt>*</tt></label>
                        <div class='row'>
                            <div class='col-12'>
                                <select
                                    class='form-control custom-form-control'
                                    onChange={(e) => setAccountType(e.target.value)}
                                    disabled={rowData?.acc_type ? true : false}
                                    value={accountType}
                                >
                                    <option value={''}>Please Select</option>
                                    <option value={'Saving Account'}>Saving Account</option>
                                    <option value={'Current Account'}>Current Account</option>
                                    <option value={'Cash Credit Account'}>Cash Credit Account</option>
                                    <option value={'Overdraft Account'}>Overdraft Account</option>
                                    <option value={'Others'}>Others</option>
                                </select>
                            </div>
                        </div>
                        <tt>
                            {errors && errors?.acc_type}
                        </tt>
                    </div>
                    <div class='form-group'>
                        <label>Account Number <tt>*</tt></label>
                        <div class='row'>
                            <div class='col-12'>
                                <input
                                    class='form-control custom-form-control'
                                    type='text'
                                    value={accountNo}
                                    disabled={rowData?.acc_no ? true : false}
                                    onChange={(e) => SetAccountNo(e.target.value.replace(/[^0-9]/g, ''))}
                                    maxlength="25"
                                />
                            </div>
                        </div>
                        <tt>
                            {errors && errors?.acc_no}
                        </tt>
                    </div>
                </div>
                <div class='d-flex align-items-center justify-content-center mt-3'>
                    <button type='button' onClick={() => setShowConfirmationModal(true)} class='btn btn-custom'>
                        OK
                    </button>
                    <button
                        type='button'
                        class='btn btn-outline-custom ml-2'
                        data-dismiss='modal'
                        onClick={toggleModal}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </Modal>
        <Modal
            state={showConfirmationModal}
            closeModal={() => setShowConfirmationModal(false)}
            style={{ width: "390px" }}
            removeBorderSpace={true}
            closeOnOverlayClick={false}
            >
			<div className='p-4' style={{'textAlign': 'center'}}>
				<p className='font-weight-bold'>
                    Are you sure, you want to submit the data?
				</p>
				<div className='d-flex align-items-center mt-4' style={{'margin-left': '120px'}}>
					<Button
						clickHandler={handleConfirmationModal}
						classNames='btn-custom'
                        disabled={loading}
					>
						{loading ? <div className='loader' /> : 'Yes'}
					</Button>
					<Button
						clickHandler={() => setShowConfirmationModal(false)}
						classNames='btn-outline-custom ml-2'
					>
						No
					</Button>
				</div>
			</div>
		</Modal>
        </>
    );
};

export default MandateModal;
